import { useContext } from "react"
import { CatalogItem } from "../../domain/catalogItem"
import { green } from '@ant-design/colors'
import ThemableButton from './ThemableButton'
import CatalogBrowserContext from "../ItemCatalog/CatalogBrowserContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  item?: CatalogItem
  name: string
  workareaId?: number
  onItemAdded: () => void
}

const AddAnotherButton = ({item, name, workareaId, onItemAdded}: Props) => {
  const { addCatalogItem } = useContext(CatalogBrowserContext)

  const disabled = !item
  return <ThemableButton
    colorPrimary={green[2] ?? ''}
    type="primary"
    shape="circle"
    size="small"
    icon={<FontAwesomeIcon icon={faPlus}/>}
    disabled={disabled}
    onClick={() => {
      if (item) {
        addCatalogItem(item, undefined, workareaId, name)
        onItemAdded()
      }
    }}
  />
}

export default AddAnotherButton